import { render, staticRenderFns } from "./Heading3.vue?vue&type=template&id=5fd4ab5c&"
import script from "./Heading3.vue?vue&type=script&lang=js&"
export * from "./Heading3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports